<mat-dialog-content>{{ confirmText | translate }}</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>{{ 'Cancel' | translate }}</button>
    <button mat-raised-button (click)="onConfirmClicked()" color="{{ color }}">{{ confirmActionText | translate }}</button>
</mat-dialog-actions>